import React from 'react';
import { Box } from '@mui/material';
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";

const Page = props => {
  const {
    children,
    sx
  } = props;

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  let boxStyle = {
    padding: isMobile ? 2 : 5
  }

  if (sx) {
    boxStyle = { ...boxStyle, ...sx };
  }

  return (
    <Box sx={boxStyle}>
      {children}
    </Box>
  )
}

export default Page;
